import { Col, Row, Select } from "antd";
import React from "react";
import { _Filter_Types } from "../../../../Home/FiltersData";

export const SelectFilterType = ({ setSelectedFilterType, selectedFilterType }) => {
	return (
		<Row>
			<Col span={10}>
				<h5>Available Types</h5>
			</Col>
			<Col span={10}>
				<Select
					placeholder="Select Filter Type"
					style={{ width: "100%" }}
					value={selectedFilterType}
					onChange={setSelectedFilterType}
				>
					{Object.entries(_Filter_Types).map(([key, value]) => (
						<Select.Option
							key={key}
							value={value}
							disabled={[
								_Filter_Types.Button,
								_Filter_Types.Date_Range,
								// _Filter_Types.Text,
								_Filter_Types.Input,
								_Filter_Types.Recursive
							].includes(value)}
						>
							{key}
						</Select.Option>
					))}
				</Select>
			</Col>
		</Row>
	);
};

export default SelectFilterType;
